import { useApp } from '@/contexts/AppContext';

export function useUserRole() {
  const { role, loading, securityLoading } = useApp();
  const isAdmin = role === 'admin';
  const isModerator = role === 'moderator';
  const isAdminOrMod = isAdmin || isModerator;

  return { role, isAdmin, isModerator, isAdminOrMod, loading: loading || securityLoading };
}
